import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SingleValue, MultiValue } from "react-select";
import CreatableSelect from "react-select/creatable";
import { Option, defaultSelectStyles } from "./Select/BaseSelect";


export interface PaginationProps {
  currentPage: number;
  onPageChange: (page: number) => void;
  totalItems: number;
    pageSize?: number;
    onPageSizeChange?: (size: number) => void;
}



const Pagination: React.FC<PaginationProps> = ({ 
  currentPage, 
  onPageChange, 
  totalItems, 
  pageSize = 10,
  onPageSizeChange
}) => {

    const {t} = useTranslation();
    const [totalPages, setTotalPages] = useState(0);
    const [localPageSize, setLocalPageSize] = useState<number>(pageSize);

    const pageSizeOptions: Option<number>[] = [
        { value: 5, label: '5' },
        { value: 10, label: '10' },
        { value: 25, label: '25' },
        { value: 50, label: '50' },
        { value: 100, label: '100' },
    ];

    useEffect(() => {
        
        setLocalPageSize(pageSize);
    }, [pageSize]);

    useEffect(() => {
        setTotalPages(Math.ceil((totalItems ?? 0) / localPageSize));
    }, [totalItems, localPageSize]);

     const handlePrevious = () => {
        if (currentPage > 1) {
        onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => { 
        if (currentPage < totalPages) {
        onPageChange(currentPage + 1);
        }
    };

    const handlePageSizeChange = (option: SingleValue<Option<number>> | MultiValue<Option<number>>) => {
        let newSize = 10;
        if (option && !Array.isArray(option)) {
            newSize = (option as Option<number>).value;
        }
        setLocalPageSize(newSize);
        if (onPageSizeChange) {
            onPageSizeChange(newSize);
        }
    };

    return (
        <div className="d-flex justify-content-between mb-3 align-items-center">
            <div className="d-flex align-items-center">
                <button
                    className="btn btn-secondary"
                    disabled={currentPage <= 1}
                    onClick={handlePrevious}>
                    {t('Previous')}
                </button>
            </div>

            <div className="d-flex align-items-center">
                <div className="me-3 d-flex align-items-center">
                    <label className="me-2 mb-0 small text-muted">{t('ItemsPerPage')}</label>
                    <div style={{ width: 80 }}>
                        <CreatableSelect
                            options={pageSizeOptions}
                            value={pageSizeOptions.find(opt => opt.value === localPageSize) || { value: localPageSize, label: String(localPageSize) }}
                            onChange={handlePageSizeChange}
                            onCreateOption={(inputValue: string) => {
                                const newSize = parseInt(inputValue, 10);
                                if (!isNaN(newSize) && newSize > 0) {
                                    setLocalPageSize(newSize);
                                    if (onPageSizeChange) {
                                        onPageSizeChange(newSize);
                                    }
                                }
                            }}
                            isClearable={false}
                            menuPlacement="top"
                            classNamePrefix="react-select"
                            styles={defaultSelectStyles}
                            formatCreateLabel={(inputValue: string) => `${t('Use')}: ${inputValue}`}
                        />
                    </div>
                </div>

                <span className="gg-page">{t('Total')}: {totalItems} | {t('Page')} {currentPage} / {totalPages}</span>
            </div>

            <button
                className="btn btn-secondary"
                disabled={currentPage >= totalPages}
                onClick={handleNext}>
                {t('Next')}
            </button>
        </div>
    )
}
export default Pagination;
